export const SET_CATEGORIES = 'SET_CATEGORIES'
export const REFRESH_CATEGORIES = 'REFRESH_CATEGORIES'
